import { formatDisplayDate } from '../../utils/dateFormat';
import { formatMoneyInr } from '../../utils/moneyFormat';

export const DAY_INDEX = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 0,
};

export const DAY_NAMES_BY_INDEX = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const GST_RATE = 0.05;
export const DELIVERY_CHARGE_PER_DAY = 20;

export const getOrCreateUserId = () => {
  const userIdKey = 'digirasa_user_id';
  const existing = localStorage.getItem(userIdKey);
  if (existing) return existing;

  const generated = `guest_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  localStorage.setItem(userIdKey, generated);
  return generated;
};

export const serializeDraftProducts = (products = []) =>
  products.map((product) => ({
    id: product.id,
    name: product.name,
    price: product.price,
    category: product.category,
    quantity: product.quantity,
    includedInPlan: Boolean(product.includedInPlan),
  }));

export const buildEmptyCustomerDetails = () => ({
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  locationArea: '',
  city: 'Hyderabad',
  country: 'India',
  pincode: '',
  address: '',
});

/** @deprecated Prefer importing formatDisplayDate from utils/dateFormat */
export const formatDateForDisplay = (value = '') => formatDisplayDate(value, value || '');

export const formatCurrency = (value = 0) => formatMoneyInr(value);

export const computeSlots = (sub) => {
  if (!sub.startDate) return [];
  const activeDays = sub.days || [];
  if (activeDays.length === 0) return [];

  const parts = sub.startDate.split('-');
  const start = new Date(Date.UTC(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2])));
  let end;
  if (sub.endDate) {
    const endParts = sub.endDate.split('-');
    end = new Date(
      Date.UTC(parseInt(endParts[0]), parseInt(endParts[1]) - 1, parseInt(endParts[2])),
    );
  } else {
    end = new Date(start);
    end.setUTCDate(end.getUTCDate() + 90);
  }

  const slots = [];
  const cur = new Date(start);
  const allowedIndices = new Set(activeDays.map((day) => DAY_INDEX[day]));
  while (cur <= end) {
    if (allowedIndices.has(cur.getUTCDay())) {
      const iso = cur.toISOString().split('T')[0];
      slots.push({
        date: iso,
        label: formatDisplayDate(iso, iso),
        dayName: activeDays.find((day) => DAY_INDEX[day] === cur.getUTCDay()),
      });
    }
    cur.setUTCDate(cur.getUTCDate() + 1);
  }
  return slots;
};
